import React, { useState, useEffect } from "react";
import NotificacionesBell from './notifications/NotificacionesBell';
import { useApi } from "../../../hooks/useApi";
import AlisonWidget from './AlisonWidget';

function TarjetaCumpleanos({ usuario }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const nombre = [usuario?.nombres || usuario?.nombre, usuario?.apellidos].filter(Boolean).join(" ") || "Colaborador";
  const cargo = usuario?.cargo || "Equipo El Gran Surtidor";
  const sede = usuario?.centroTrabajo || usuario?.sede || "Sede Principal";

  return (
    <>
      <style>{`
        .firework { position: absolute; top: 50%; left: 50%; width: 5px; height: 5px; border-radius: 50%; box-shadow: 0 0 0 0 #fff; animation: firework-anim 1.5s infinite ease-out; }
        .firework.delay { animation-delay: 0.75s; left: 80%; top: 30%; }
        .firework.delay2 { animation-delay: 0.3s; left: 20%; top: 70%; }
        @keyframes firework-anim { 0% { box-shadow: 0 0 0 0 #ff0, 0 0 0 0 #f0f, 0 0 0 0 #0ff; transform: scale(0.5); opacity: 1; } 50% { opacity: 1; } 100% { box-shadow: 0 -90px 0 0 transparent, 60px -60px 0 0 transparent, 90px 0 0 0 transparent, 60px 60px 0 0 transparent, 0 90px 0 0 transparent, -60px 60px 0 0 transparent, -90px 0 0 0 transparent, -60px -60px 0 0 transparent; transform: scale(1.4); opacity: 0; } }
        .cake-wrapper { position: relative; width: 140px; height: 110px; margin: 0 auto; transform: scale(0.85); }
        .plate { position: absolute; bottom: 0; width: 100%; height: 12px; background: #e2e8f0; border-radius: 10px; box-shadow: 0 4px 6px rgba(0,0,0,0.2); animation: bounce-in 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
        .layer-bottom { position: absolute; bottom: 12px; left: 10px; width: 120px; height: 35px; background: linear-gradient(90deg, #ec4899, #f43f5e); border-radius: 8px; animation: slide-up 0.8s ease 0.2s both; }
        .layer-top { position: absolute; bottom: 47px; left: 20px; width: 100px; height: 30px; background: linear-gradient(90deg, #d946ef, #a855f7); border-radius: 8px; animation: slide-up 0.8s ease 0.4s both; }
        .icing { position: absolute; bottom: 70px; left: 18px; width: 104px; height: 15px; background: #ffffff; border-radius: 10px; box-shadow: 0 4px 0 #fbcfe8; animation: slide-up 0.8s ease 0.6s both; }
        .candle-stick { position: absolute; bottom: 82px; left: 63px; width: 14px; height: 30px; background: repeating-linear-gradient(45deg, #fff, #fff 4px, #3b82f6 4px, #3b82f6 8px); border-radius: 3px; animation: scale-in 0.5s ease 0.8s both; }
        .candle-flame { position: absolute; bottom: 110px; left: 62px; width: 16px; height: 26px; background: #ff9900; border-radius: 50% 50% 20% 20%; box-shadow: 0 0 15px #ff9900, 0 0 30px #ffcc00; animation: flicker 0.6s infinite alternate ease-in-out, scale-in 0.5s ease 1s both; }
        @keyframes bounce-in { 0% { transform: scale(0); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
        @keyframes slide-up { 0% { transform: translateY(40px); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
        @keyframes scale-in { 0% { transform: scale(0); } 100% { transform: scale(1); } }
        @keyframes flicker { 0% { transform: scale(1) rotate(-3deg); background: #ff9900; } 100% { transform: scale(1.2) rotate(3deg); background: #ffea00; } }
      `}</style>

      <div className="w-full mb-8 bg-gradient-to-r from-purple-900/90 via-fuchsia-900/90 to-pink-900/90 backdrop-blur-xl rounded-[28px] p-6 sm:p-8 shadow-2xl border border-pink-300/30 text-white relative overflow-hidden flex flex-col lg:flex-row items-center justify-between gap-6 btn-interactive">
        <div className="firework"></div><div className="firework delay"></div><div className="firework delay2"></div>
        <div className="shrink-0"><div className="cake-wrapper"><div className="candle-flame"></div><div className="candle-stick"></div><div className="icing"></div><div className="layer-top"></div><div className="layer-bottom"></div><div className="plate"></div></div></div>
        <div className="text-center lg:text-left flex-1 z-10">
          <span className="bg-pink-500/30 text-pink-200 border border-pink-400/30 text-[10px] font-black px-3.5 py-1 rounded-full uppercase tracking-widest inline-block mb-2 shadow-sm">✨ Celebración Especial ✨</span>
          <h2 className="text-2xl sm:text-3xl font-black tracking-tight text-white drop-shadow-md">¡Feliz Cumpleaños, {nombre.toUpperCase()}! 🥳</h2>
          <p className="text-xs sm:text-sm text-pink-100 font-medium mt-1 leading-relaxed max-w-2xl">Hoy celebramos tu vida y el gran valor que aportas a <strong className="text-white">{sede}</strong> como <strong className="text-white">{cargo}</strong>.</p>
        </div>
        <button onClick={() => setVisible(false)} className="btn-interactive px-6 py-3.5 bg-white/10 hover:bg-white/20 border border-white/30 text-white rounded-2xl font-black text-xs shadow-xl shrink-0 cursor-pointer uppercase tracking-wider z-10 backdrop-blur-sm">¡Muchas Gracias! 🎉</button>
      </div>
    </>
  );
}

export default function Dashboard({ user, onLogout, onSelectModule, onOpenEstructura }) {
  const { request, loading } = useApi();
  const [modulosValidos, setModulosValidos] = useState([]);
  const [errorLocal, setErrorLocal] = useState(false);
  const [mostrarAlison, setMostrarAlison] = useState(false); 

  const nombreCompleto = [user?.nombres || user?.nombre, user?.apellidos].filter(Boolean).join(" ") || "Usuario";
  const esSuperAdmin = String(user?.cargo || "").toUpperCase().trim() === 'SUPER_ADMIN';

  useEffect(() => {
    const cargarModulos = async () => {
      if (!user || (!user.documento && !user.nit)) return;
      const doc = user.documento || user.nit; 
      
      const { success, data } = await request(`/usuarios/modulos-permitidos/${doc}`);
      if (success) {
        setModulosValidos(data.modulos || []);
      } else {
        setErrorLocal(true);
      }
    };
    cargarModulos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (!user) return;
    let tienePermisoAlison = false;
    try {
      const parsed = typeof user.permisos_avanzados === 'string' ? JSON.parse(user.permisos_avanzados) : (user.permisos_avanzados || {});
      const micros = parsed.micros || parsed;
      tienePermisoAlison = micros['Alison'] === true || micros['alison'] === true;
    } catch (e) {
      tienePermisoAlison = false;
    }
    setMostrarAlison(esSuperAdmin || tienePermisoAlison);
  }, [user, esSuperAdmin]);

  const esCumpleanosHoy = () => {
    const fechaNac = user?.fecha_nacimiento || user?.empl_fecnac;
    if (!fechaNac) return false; 
    try {
      const hoy = new Date();
      const [, mesNac, diaNac] = fechaNac.split('T')[0].split('-');
      return parseInt(mesNac, 10) === (hoy.getMonth() + 1) && parseInt(diaNac, 10) === hoy.getDate();
    } catch { return false; }
  };

  return (
    <div className="min-h-screen w-full flex flex-col relative">
      <div className="absolute inset-0 bg-slate-900/5 backdrop-blur-[2px] z-0 transition-colors duration-700"></div>

      <div className="w-full flex flex-col p-4 sm:p-8 flex-1 justify-center items-center z-10 relative">
        <div className="w-full max-w-[1400px] glass-panel rounded-[40px] p-6 sm:p-10 animate-fade-in-up relative">
          
          {esCumpleanosHoy() && <TarjetaCumpleanos usuario={user} />}

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-white/30 pb-6 mb-8 gap-4 pt-2 sm:pt-0">
            <div>
              <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight drop-shadow-sm flex items-center gap-3">
                Panel de Módulos
              </h1>
              <p className="text-sm text-slate-800 font-medium mt-2">Bienvenido(a), <span className="font-black text-slate-900">{nombreCompleto.toUpperCase()}</span></p>
              <p className="text-xs text-slate-700 font-bold mt-1">
                Cargo: <span className="text-blue-700 bg-blue-50/50 px-2 py-0.5 rounded-md">{user?.cargo?.toUpperCase() || "SIN CARGO"}</span>
              </p>
            </div>
            <div className="flex items-center gap-4 w-full sm:w-auto justify-end">
              <NotificacionesBell usuario={user} />
              <button onClick={onLogout} className="btn-interactive px-6 py-2.5 text-xs font-bold text-red-600 bg-white/70 hover:bg-red-50 hover:text-red-700 rounded-full shadow-sm border border-red-100/50 cursor-pointer flex items-center gap-2">
                <span>Cerrar sesión</span>
              </button>
            </div>
          </div>

          {esSuperAdmin && (
            <div className="bento-card p-5 mb-8 flex flex-col lg:flex-row justify-between items-center gap-5 animate-smooth-modal">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-slate-800/10 flex items-center justify-center text-2xl shadow-inner border border-slate-200">🛠️</div>
                <div>
                  <h3 className="text-xs font-black text-slate-800 tracking-wider">PANEL DE CONTROL SUPER ADMIN</h3>
                  <p className="text-[10px] text-slate-600 font-bold uppercase">Gestión de perfiles, menús y notificaciones masivas.</p>
                </div>
              </div>
              <div className="flex flex-wrap gap-3 justify-center">
                <button onClick={onOpenEstructura} className="btn-interactive cursor-pointer px-6 py-3 bg-slate-900 hover:bg-slate-800 text-white text-[11px] font-black rounded-2xl shadow-lg flex items-center gap-2 tracking-wide uppercase">
                  ⚙️ Abrir Panel de Herramientas Super Admin
                </button>
              </div>
            </div>
          )}

          {loading && (
            <div className="py-24 flex flex-col items-center justify-center text-slate-700 animate-smooth-modal">
              <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4 shadow-sm"></div>
              <p className="font-bold text-sm tracking-widest uppercase animate-pulse">Cargando tu entorno de trabajo...</p>
            </div>
          )}

          {(!loading && errorLocal) && (
            <div className="bento-card bg-red-50/50 border border-red-200 p-6 text-red-700 text-sm font-bold text-center mb-6 animate-smooth-modal">
              Hubo un problema al cargar los accesos. Verifica tu conexión con el servidor.
            </div>
          )}

          {(!loading && !errorLocal && modulosValidos.length === 0) && (
            <div className="glass-panel py-16 text-center text-slate-600 font-medium rounded-3xl animate-smooth-modal">
              <span className="text-5xl block mb-4 opacity-50 icon-bounce">🔒</span>
              <p>No tienes módulos asignados. Contacta al administrador para solicitar acceso.</p>
            </div>
          )}

          {!loading && !errorLocal && modulosValidos.length > 0 && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {modulosValidos.map((mod, index) => (
                <div 
                  key={mod.key || index} 
                  onClick={() => onSelectModule && onSelectModule(mod.key)} 
                  className="bento-card p-6 flex flex-col justify-between h-full relative group cursor-pointer animate-smooth-modal delay-100"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>

                  <div className="relative z-10">
                    <div className="w-14 h-14 rounded-2xl bg-blue-50/80 text-blue-600 flex items-center justify-center text-3xl mb-5 shadow-inner border border-blue-100/50 group-hover:scale-110 group-hover:bg-white group-hover:-rotate-6 transition-all duration-500 ease-out icon-bounce">
                      {mod.icon}
                    </div>
                    
                    <h3 className="font-extrabold text-slate-900 text-[17px] tracking-tight mb-2 leading-tight group-hover:text-blue-700 transition-colors duration-300">
                      {mod.title}
                    </h3>
                    <p className="text-[12px] text-slate-500 font-medium leading-relaxed mb-6 line-clamp-2">
                      {mod.description}
                    </p>
                  </div>
                  
                  <div className="flex justify-between items-center mt-auto pt-4 border-t border-slate-200/50 relative z-10">
                    <span className={`text-[10px] font-black px-3 py-1.5 rounded-lg uppercase tracking-widest transition-colors duration-300 ${esSuperAdmin ? 'text-emerald-700 bg-emerald-50/80 group-hover:bg-emerald-100' : 'text-blue-700 bg-blue-50/80 group-hover:bg-blue-100'}`}>
                      {esSuperAdmin ? 'ACCESO TOTAL' : 'ACTIVO'}
                    </span>
                    
                    <span className="text-blue-600 text-[13px] font-black opacity-0 transform translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500 ease-out flex items-center gap-1">
                      Ingresar <span className="text-xl leading-none">›</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      
      {mostrarAlison && (
        <div className="relative z-[9999]">
            <AlisonWidget usuario={user} />
        </div>
      )}
    </div>
  );
}